import { Box, Grid, GridSize } from '@material-ui/core'
import React, { useContext, useState } from 'react'
import buildStyles from './styles'
import { useWindowSize } from '../../../hooks/useWindowSize'
import { MOBILE_WIDTH_HIGH } from '../../../constants/constants'
import AppContext from '../../context'
import Goal from './Goal'
import { GoalInfo } from '../../../api/types'
import EntityInfo from '../../../components/popups/entity-info/EntityInfo'
import HeaderInfo from '../../../components/header-info/HeaderInfo'
import { getSize } from '../../../utils/functions'

const GoalsView = () => {
  const { state } = useContext(AppContext)

  const [showedGoal, setShowedGoal] = useState<GoalInfo | null>(null)

  const screen = useWindowSize()
  const isMobile: boolean = (screen.width as number) < MOBILE_WIDTH_HIGH

  const count = state.goals ? state.goals.length : 0
  const size = getSize(count)

  if (!state.locationDesignConfig) return null

  const styles = buildStyles({
    baseColors: state.locationDesignConfig?.baseColors,
  })

  return (
    <>
      <HeaderInfo
        title="Pomóż nam uzbierać środki!"
        arrowedTitle="WPŁAĆ DAROWIZNĘ NA WYBRANY CEL"
        orgName={state.selectedOrganization?.name}
        addedPadding={!isMobile}
        addedSmallPadding={isMobile}
      />

      {state.goals && state.goals.length > 0 && (
        <Box
          width="100%"
          margin="0 20px"
          maxWidth="1100px"
          className={styles.container}
        >
          <Grid container alignItems="center" justify="center">
            {state.goals.map((goal, index) => {
              return (
                <Grid
                  key={index}
                  item
                  xs={size[0] as GridSize}
                  sm={size[1] as GridSize}
                  md={size[2] as GridSize}
                  lg={size[3] as GridSize}
                  xl={size[4] as GridSize}
                  className={styles.itemContainer}
                >
                  <Goal
                    isBigger={state.goals.length <= 3}
                    goal={goal}
                    setShowedGoal={setShowedGoal}
                  />
                </Grid>
              )
            })}
          </Grid>
        </Box>
      )}

      {showedGoal && (
        <EntityInfo
          title={showedGoal.name}
          subtitle={showedGoal.description}
          isOpen={!!showedGoal}
          onClose={() => setShowedGoal(null)}
          maxWidth="md"
          fullWidth
        />
      )}
    </>
  )
}

export default GoalsView
